computedMarkers = (dependentKey) ->

  options =
    # При добавлении заказа
    addedItem: (array, order, changeMeta, instanceMeta) ->
      if order.get('takeaway')
        lat = order.get('restaurant.latitude')
        lon = order.get('restaurant.longitude')
      else
        lat = order.get('latitude')
        lon = order.get('longitude')

      marker = null

      if lat and lon and window.ymaps
        coordinates = [lat, lon]
        marker = new ymaps.Placemark(coordinates,{},{
          iconLayout:     'default#image'
          iconImageHref:  order.get('marker')
          iconImageSize: [22, 22]
          iconImageOffset: [-22, -22]
        })
        @get('map').geoObjects.add(marker)
        @registerMarker(marker)

        marker.events.add("click", () =>
          @sendAction('onOrderSelected', order)
        )
      array.insertAt changeMeta.index, { marker: marker, model: order }
      array

  Em.arrayComputed(dependentKey, options)

###
# Маркеры для курьеров
###
renderCouriers = ->

  showCourierPopup = (courier, currentOrder, marker, e) =>
    ctx = @
    courier.getStatus()
    .then =>
      marker.properties.set({
        balloonHeader: courier.get('name'),
        balloonContent: getInfoWindowContent(courier, currentOrder),
      })
      marker.options.set({
        balloonMaxWidth: 500,
        balloonCloseTimeout: Infinity
      })
      marker.balloon.open(e.get('coords'))
      Em.run.next =>
    
        content = document.querySelector('.courier-info-window')

        isBefore = (el1, el2) ->
          if el1.parentNode == el2.parentNode
            cur = el1.previousSibling
            while cur
              return true if cur == el2
              cur = cur.previousSibling
          false

        el = null
        items = content.querySelectorAll('li')
        list = content.querySelector('ul')
        idsArr = Array.from((list?.querySelectorAll('li') or [])).map (el) => Number el.dataset.orderId

        if list and items
          list.addEventListener 'dragover', (e) ->
            e.preventDefault()

          items.forEach (item) ->
            item.setAttribute 'draggable', true

            item.addEventListener 'dragstart', (e) ->
              e.dataTransfer.effectAllowed = 'move'
              e.dataTransfer.setData 'text/plain', null
              el = e.target

            item.addEventListener 'dragend', (e) ->
              el.classList.remove 'hidden'
              el = null
              updateIdsArr(ctx)

            item.addEventListener 'dragover', (e) ->
              e.preventDefault()
              el.classList.add 'hidden'
              if el != e.target && el.parentNode == e.target.parentNode
                if isBefore el, e.target
                  e.target.parentNode.insertBefore el, e.target
                else
                  e.target.parentNode.insertBefore el, e.target.nextSibling

            item.addEventListener 'dragenter', (e) ->
              e.preventDefault()

        updateIdsArr = (ctx) ->
          newIdsArr = Array.from(list.querySelectorAll('li')).map (el) => Number el.dataset.orderId
          if !_.isEqual(newIdsArr, idsArr)
            idsArr = newIdsArr
            previousIdsArr = newIdsArr
            courier.nonRESTAction('POST', 'update_priorities', {order_ids: idsArr}).then (data)=>
              ctx.get('notifier').pushNotification
                type: 'success'
                message: data.message
                duration: 3000

        if currentOrder && false
          currentOrder.get('restaurant')
          .then (restaurant) =>
            restaurantMarker = @get('restaurantsMarkers').get(restaurant.get('id'))
            address_marker = @get('markers').findBy('model', currentOrder)?.marker

            from_point = marker.getCoordinates()
            if courier.get('status') == 'delivering'
              to_point = address_marker?.getCoordinates()
            else
              to_point = restaurantMarker.getCoordinates()

            @drawLine(from_point, to_point)

  findOrCreateMarker = (courier) =>
    if !@get('courierMarkerCache')
      @set('courierMarkerCache', Em.A([]))

    match = @get('courierMarkerCache').filter (m) =>
      m.id is courier.get('id')
    if match and match.length >= 1
      return match[0]
    return unless window.ymaps
    coordinates = [courier.get('lat'), courier.get('lon')]

    MyIconContentLayout = ymaps.templateLayoutFactory.createClass("
        <div class='courier-avatar #{courier.get('status')}' id='avatar-#{courier.get('id')}'>
          <div class='avatar-container'>
            <img src='#{courier.get('avatarUrl')}'/>
          </div>
        </div>")
        
    marker = new ymaps.Placemark(coordinates, {}, {
      iconContentLayout: MyIconContentLayout
      iconLayout: 'default#imageWithContent'
      iconImageHref: 'assets/images/transparent.png',
      iconImageSize: [40, 40]
      iconImageOffset: [-40, -40]
    })

    marker.events.add 'click', (e) =>
      courier.get('currentOrder')
      .then (currentOrder) =>
        showCourierPopup(courier, currentOrder, marker, e)
  
    id = courier.get('id')
    markerObj = Em.Object.create({ id, marker })
    @get('courierMarkerCache').pushObject(markerObj)
    markerObj


  formatDate = (date, tz) =>
    d = moment(new Date date)
    d = d.tz(tz) if tz
    if d.isSame(moment(), 'day')
      d.format('H:mm')
    else
      d.format('DD MMMM в H:mm')



  getInfoWindowContent = (courier, currentOrder) =>
    params = {}
    if currentOrder
      params = {
        restaurant: currentOrder.get('restaurant.name'),
        address: currentOrder.get('address_text')
      }

    ret = "<div class='courier-info-window'>
        <h4>#{courier.get('name')}</h4>
        <p>#{Em.I18n.t 'orders_map.courier_popup.statuses.' + courier.get('status'), params}</p>"

    if currentOrder
      ret += "<a class='order-number' href='#/orders/map/#{currentOrder.get('id')}?f=current'>
        #{Em.I18n.t 'order.map_popup.order_name', order: currentOrder.get('number')}
      </a>"


    orders = courier.get('statusData').orders

    if orders.length > 0
      ret += '<h5>Очередь заказов</h5>'
      ret += '<ul>'
      orders.forEach (order) =>

        pickup = formatDate(order.picked_up_at || order.pick_up_at, currentOrder?.get('timezone'))
        delivery_at = formatDate(order.delivery_at, currentOrder?.get('timezone'))

        ret += "<li data-order-id='#{order.id}'>
        <img class='drag-indicator' src='images/drag-indicator.svg'/>
          <div>
            #{Em.I18n.t 'order.status.'+order.status}<br>
            <a class='order-number' href='#/orders/map/#{order.id}?f=current'>
              №#{order.number}
            </a>
          </div>
          <div>#{pickup}<br>#{order.restaurant_name}</div>
          <div>&rarr;</div>
          <div>#{delivery_at}<br>#{order.address}</div>
        </li>"

      ret += '</ul>'

    ret += "</div>"

  i = 0
  @get('courierPositions').forEach (c) =>
    @obtainMap().then =>
      hideUnathorizedCouriers = localStorage.getItem('hideUnauthorizedCouriers') == 'true'
      renderCourierMarker = if hideUnathorizedCouriers then c.get('lat') && c.get('lng') && c.get('status') != 'offline' && c.get('is_running') else c.get('lat') && c.get('lng')
      m = findOrCreateMarker( c )
      marker = m.get('marker')
      
      if renderCourierMarker
        @registerMarker(marker)
      else
        @removeMarker(c, marker, @get('courierMarkerCache'))


      pos    = [c.get('lat'), c.get('lng')]
      oldPos = marker.geometry.getCoordinates()

      if oldPos[0] != pos[0] || oldPos[1] != pos[1]
        marker.geometry.setCoordinates( pos )
      
      MyIconContentLayout = ymaps.templateLayoutFactory.createClass("
        <div class='courier-avatar #{courier.get('status')}' id='avatar-#{courier.get('id')}'>
          <div class='avatar-container'>
            <img src='#{courier.get('avatarUrl')}'/>
          </div>
        </div>")
      marker.options.set({
        iconLayout: 'default#imageWithContent',
        iconImageHref: 'assets/images/transparent.png',
        iconContentLayout: MyIconContentLayout,
        iconImageSize: [36, 36],
        iconImageOffset: [-36, -36]
      })

App.OrdersMapYandexComponent = Em.Component.extend
  ###
  # Поля
  ###
  classNames: [ 'orders-map', 'orders-map-yandex', 'delivery-map-component' ]
  map:           null
  orders:        null
  restaurants:   null
  selectedOrder: null
  markers:        computedMarkers('orders', 'map')
  session:  Em.inject.service()
  notifier: Em.inject.service('notifier')
  yandexMapsService: Em.inject.service('yandexMaps')

  animateNewMarkers: false

  redrawCouriers: renderCouriers.observes('courierPositions')
  courierMarkerCache: null

  initializeProps: (->
    @set('obtainDefers', Em.A([]))
  ).on('init')

  # глобальная структура для регистрации всех маркеров, добавленных на карту
  # чтобы удалять их перед записью карты в кеш при выходе
  registerMarker: (marker) ->
    map = @get('map')
    map.geoObjects.add(marker)
    window.cachedMarkers = [] unless window.cachedMarkers
    window.cachedMarkers.push marker

  removeMarker: (c, marker, cache) ->
    return unless c or marker
    map = @get('map')
    map.geoObjects.remove(marker)
    cachedMarkers = cache || []
    index = cachedMarkers.findIndex (m) =>
      m.id is c.get('id')
    cachedMarkers.splice(index, 1) if index > -1

  registerLine: (line) ->
    map = @get('map')
    map.geoObjects.add(line)
    window.cachedLines = [] unless window.cachedLines
    window.cachedLines.push line

  clearLines: () ->
    map = @get('map')
    return false unless window.cachedLines
    window.cachedLines.forEach (line) ->
      map.geoObjects.remove(line)
    window.cachedLines = []

  extendBounds: (position, bounds=null) ->
    if bounds == null
      bounds = []

    if Em.isEmpty bounds
      bounds.push = position.map((x) => x)
      bounds.push = position.map((x) => x)
    else
      bounds[0] = position[0] if bounds[0][0] > position[0]
      bounds[1] = position[1] if bounds[1][1] > position[1]

      bounds[0] = position[0] if bounds[0][0] < position[0]
      bounds[1] = position[1] if bounds[1][1] < position[1]
    bounds

  ###
  # Методы
  ###
  didInsertElement: ->
    @get('yandexMapsService').retrieve()
    .then (ymaps) =>
      ymaps.ready(@initializeMap.bind(@))

  initializeMap: ->
    map = new ymaps.Map 'yandex-map',
      center: [55.76, 37.64]
      zoom: 7
      controls: ['zoomControl']
    # Инициализируем все поля
    @set('map', map)

    @addRestaurantsMarkers()
    @fitBounds()


    @set('initialized', true)
    @trigger('mapInitialized')
    @get('obtainDefers').forEach (defer) =>
      defer.resolve(map)

  ###
  # Центрирование карты
  ###
  fitBounds: ->
    # return

    map = @get('map')
    bounds = {}

    markersCollection = new ymaps.GeoObjectCollection()

    @get('markers').filter (m) => m.marker
    .forEach (m) =>
      marker = new ymaps.Placemark(m.marker.geometry.getCoordinates(), {}, {opacity: 0})
      markersCollection.add(marker)

    @get('restaurants').forEach (restaurant) =>
      if restaurant.get('hasCoordinates')
        coordinates = [restaurant.get('latitude'), restaurant.get('longitude')]
        marker = new ymaps.Placemark(coordinates, {}, {opacity: 0})
        markersCollection.add(marker)

    if markersCollection.getLength() > 0
      map.geoObjects.add(markersCollection)
      map.setBounds(markersCollection.getBounds(),
        duration: 200, margin: 80)
      map.geoObjects.remove(markersCollection)

  # ---
  # Запрашивает экземпляр карты. Гарантирует, что карта инициализирована
  # ---
  obtainMap: ->
    defer = Em.RSVP.defer()

    if @get('initialized')
      defer.resolve(@get('map'))
    else
      @get('obtainDefers').pushObject(defer)

    defer.promise

  ###
  # Добавить рестораны на карту
  ###
  addRestaurantsMarkers: ->

    map       = @get('map')
    icon = "images/map-markers/restaurant-marker-round.png"

    @set('restaurantsMarkers', Ember.Object.create())

    @get('restaurants')
    .filter (r) => r.get('hasCoordinates')
    .forEach (restaurant) =>
      lat = restaurant.get('latitude')
      lon = restaurant.get('longitude')

      coordinates = [lat, lon]

      marker = new ymaps.Placemark(coordinates,{},{
        iconLayout: 'default#image'
        iconImageHref: icon,
        iconImageSize: [26, 26],
        iconImageOffset: [-20, -20]
      })
      map.geoObjects.add(marker)


      @get('restaurantsMarkers').set(restaurant.get('id'), marker)


  clearLines: () ->
    map = @get('map')
    return false unless window.cachedLines
    window.cachedLines.forEach (line) ->
      map.geoObjects.remove(line) if line
    window.cachedLines = []


  ###
  # Центрирование по маркеру
  ###
  onSelectedOrderChanged: (->
    @obtainMap()
    .then (map) =>

      return unless @get('selectedOrder')?

      order = @get('selectedOrder')

      order.reload()
      .then =>
        order.get('restaurant')
        .then (restaurant) =>
          return unless restaurant

          restaurantMarker = @get('restaurantsMarkers').get(restaurant.get('id'))
          marker = @get('markers').findBy('model', order)?.marker

          return unless marker

          unless restaurantMarker
            @get('map').state.set({
              zoom: 17,
              center: marker.geometry.getCoordinates() 
            })
            return

          orderPosition      = marker.geometry.getCoordinates()
          restaurantPosition = restaurantMarker.geometry.getCoordinates()

          @drawLine(orderPosition, restaurantPosition)

  ).observes('selectedOrder').on('didInsertElement')


  onOrderStatusChanged: (->
    @obtainMap()
    orders = @get('orders')
    orders.forEach (order) =>
      map = @get('map')
      marker = @get('markers').findBy('model', order)?.marker
      cachedLine = if window.cachedLines then window.cachedLines.find (line) => line.userData == order.get('id') else null
      if marker
        if order.get('status') == 'complete' 
          map.geoObjects.remove(marker)
          if cachedLine
            map.geoObjects.remove(cachedLine)
        else
          lat = null
          lon = null

          if order.get('takeaway')
            lat = order.get('restaurant.latitude')
            lon = order.get('restaurant.longitude')
          else
            lat = order.get('latitude')
            lon = order.get('longitude')
          
          coordinates = [lat, lon]
          marker.geometry.setCoordinates(coordinates)
          marker.options.set({
            iconImageHref:  order.get('marker')
          })
        
  ).observes('orders.@each.status')


  drawLine: (from, to) ->
    @clearLines()
    map = @get('map')

    return unless from and to

    
    polyline = new ymaps.Polyline([
      from, to
    ], {},{
      strokeWidth:  3,
      strokeColor: '#00b7ff',
      strokeStyle: {
        style: "dot",
        offset: 8
      },
      coordRendering: 'shortestPath',
      userData: @get('selectedOrder').get('id')
    })

    @registerLine(polyline)
    map.setBounds(polyline.geometry.getBounds())